import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

import ProjectPageShell, { Crumb } from "../shared/ProjectPageShell";
import CalendarCreation from "./calendarCreation";

const CalendarCreationPage: FC = () => {
  const navigate = useNavigate();

  // Handle navigation back to calendar list
  const handleBackToCalendarList = () => {
    navigate("/pms/calendar");
  };

  // Handle successful creation
  const handleSuccess = () => {
    navigate("/pms/calendar");
  };

  const breadcrumb: Crumb[] = [
    { label: "Calendars", onClick: handleBackToCalendarList },
    { label: "New Calendar" },
  ];

  return (
    <ProjectPageShell
      headTitle="New Calendar Creation"
      breadcrumb={breadcrumb}
      title="New Calendar"
      eyebrow="Calendar"
      onBack={handleBackToCalendarList}
    >
      <CalendarCreation isOpen={true} onSuccess={handleSuccess} />
    </ProjectPageShell>
  );
};

export default CalendarCreationPage;
